import { ADS_PAGE_PATH_ALIAS } from 'application/pages/AdsPage';
import { useNavigate } from 'application/providers/RouterProvider';
import { DEFAULT_ERROR_MESSAGE } from '@shared/config';

import { toast } from '@shared/ui';

import { NOTIFICATIONS_TEXT } from '../consts';
import { UseAdRemoveModalControllerProps } from './types';

const useAdRemoveModalController = ({
  id,
  close,
  removeAdCampaign,
  clearAdCampaigns,
}: UseAdRemoveModalControllerProps) => {
  const navigate = useNavigate();

  const onAdCampaignRemove = async () => {
    try {
      const okRemove = await removeAdCampaign(id);

      if (!okRemove) {
        throw new Error();
      }

      navigate(ADS_PAGE_PATH_ALIAS);

      toast.info(NOTIFICATIONS_TEXT.REMOVE_SUCCESS);

      clearAdCampaigns();
      close();
    } catch (e) {
      toast.error(DEFAULT_ERROR_MESSAGE);
    }
  };

  return {
    onAdCampaignRemove,
  };
};

export default useAdRemoveModalController;
